import * as s from "../TableItemStyled";
import { useState } from "react";
import { useQuery } from "react-query";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { DashboarAlertLatest } from "api/interfaces/dashboardInterface.interface";
import { postDashboardAlertLatest } from "api/dashboardAPI";
import AccountSelects from "../AccountSelects";
import { useMediaQuery } from "react-responsive";
import { desktop } from "components/MediaQuery";
import TableItemHeader from "../TableItemHeader";
import { Layout } from "react-grid-layout";
import { TableItemName } from "utils/WidgetUtil";
import SearchInput from "components/atoms/input/search/SearchInput";
import NoData from "components/templates/nopage/NoData";
import AlertList from "pages/dashboard/common/alerts/AlertList";
import * as cs from "pages/dashboard/common/CommonStyled";
import useStompDebouncedRefetch, {
  StompDateSignalKey,
} from "hook/useStompDebouncedRefetch";

interface Props {
  layout: Layout;
  chartLayout: Layout[];
  onDeleteWidget: (key: TableItemName) => void;
  onLayoutChange: (layout: Layout[]) => void;
}

export default function AlertFeed(props: Props): JSX.Element {
  const isDesktop = useMediaQuery({ minWidth: desktop });
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const [accountIds, setAccountIds] = useState<string[]>([]);
  const [alertsData, setAlertsData] = useState<DashboarAlertLatest[]>([]);

  const [keyword, setKeyword] = useState<string>("");
  const getAlertLatest = useQuery(
    ["getAlertLatest", selectedAccount.accountId, accountIds, keyword],
    () =>
      postDashboardAlertLatest({
        accountId: selectedAccount.accountId,
        maxCount: isDesktop ? 30 : 5,
        payload: {
          accountIds,
          keyword,
        },
      }),
    {
      retry: 0,
      // refetchInterval: 10000,
      refetchOnWindowFocus: false,
      onSuccess: (res: any) => {
        // console.log(res, "res ---");
        if (res?.result) {
          // console.log(res.result, "alert latest");
          setAlertsData(
            (res.result || []).map(
              (item: DashboarAlertLatest, index: number) => ({
                ...item,
                key: index,
              })
            )
          );
        } else {
          setAlertsData([]);
        }
      },
      onError: (e: any) => {
        console.log(e, "error");
      },
    }
  );
  useStompDebouncedRefetch({
    stompKey: ["alertListUpdated"] as StompDateSignalKey[],
    refetch: getAlertLatest.refetch,
  });
  const onChangeAccount = (value: string[]) => {
    setAccountIds(value);
  };

  const onClickSearch = (keyword: string) => {
    setKeyword(keyword);
  };

  return (
    <>
      <TableItemHeader
        layout={props.layout}
        chartLayout={props.chartLayout}
        onDeleteWidget={props.onDeleteWidget}
        onLayoutChange={props.onLayoutChange}
        isError={getAlertLatest.isError}
      />
      <s.Contents className="drag-cancel-content">
        <s.ContentWrapper>
          <s.ContentHeader>
            <div>
              <AccountSelects onChange={onChangeAccount} value={accountIds} />
            </div>
            <div className="dashboard-search-input">
              <SearchInput onClickSearch={onClickSearch} />
            </div>
          </s.ContentHeader>
          <s.ContentInner>
            {alertsData.length === 0 ? (
              <div className="no-data-wrapper">
                <NoData />
              </div>
            ) : (
              <cs.Scroll>
                <AlertList data={alertsData} />
              </cs.Scroll>
            )}
          </s.ContentInner>
        </s.ContentWrapper>
      </s.Contents>
    </>
  );
}
